import Vue from 'vue'
import store from '@/store'
import components from '@/components'
import filters from '@/filters'
import '@/styles/commons.scss'
import 'swiper/dist/css/swiper.css'
import '@/plugins/index'
import clickoutside from './directives/clickoutside'
export const RELEASE_VERSION = 'release_v1.0.0'

window.console.log(`version: ${RELEASE_VERSION}`)

Vue.use(components)
Vue.use(filters)

Vue.directive('click-outside', clickoutside)



// WEBPACK FOOTER //
// ./src/base.js